import { type FC, useMemo } from 'react';

import { BrandedSearchFooterComponent } from '@vakantiesnl/components/src/__LEGACY__/molecules/BrandedSearchFooter';
import { type BrandedSearchPageTemplate } from '@vakantiesnl/services/src/contentful/brandedSearchTemplate';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';

export const BrandedSearchFooterBlock: FC<
	Pick<BrandedSearchPageTemplate, 'footerImages' | 'footerTitle' | 'shortFooterDescription' | 'description'>
> = ({ footerImages, footerTitle, shortFooterDescription, description }) => {
	const microCopies = useMicroCopyContext();

	const images = useMemo(() => footerImages?.map((asset) => asset.url), [footerImages]);

	return (
		<BrandedSearchFooterComponent
			title={footerTitle}
			images={images}
			description={shortFooterDescription}
			microCopies={microCopies}
			richText={description}
		/>
	);
};
